import { toast as hotToast } from 'react-hot-toast';

/**
 * Hook useToast compatible avec shadcn/ui
 * Utilise react-hot-toast en arrière-plan
 */

export const useToast = () => {
  const toast = ({ title, description, variant = 'default', ...props }) => {
    const message = description || title;
    
    switch (variant) {
      case 'destructive':
        return hotToast.error(message, {
          duration: 4000,
          position: 'top-right',
          ...props
        });
      case 'success':
        return hotToast.success(message, {
          duration: 3000,
          position: 'top-right',
          ...props
        });
      default:
        return hotToast(message, {
          duration: 3000,
          position: 'top-right',
          ...props
        });
    }
  };

  return { toast };
};
